import { AppEnvName } from '@cvs-web/splash-components/server';

export interface ExpHeaderKeys {
  readonly clientId: string;
  readonly experienceId: string;
}

export interface EnvironmentConfig {
  readonly envName: AppEnvName;
  readonly domain: string[];
  readonly infoAPI: string;
  readonly defaultHeaderURL?: string;
  readonly infoAPIHeader: string | undefined;
  readonly experienceApiQee: string;
  readonly experienceClientId: string;
  readonly getCommPrefsExperienceId: string;
  readonly getH100CommPrefsExperienceId: string;
  readonly getRxCommPrefsExperienceId: string;
  readonly getH100RxCommPrefsExperienceId: string;
  readonly getExtraCareProfileInfoExperienceId: string;
  readonly updateExtraCareProfileInfo: string;
  readonly getExtracareInfoHeaderKeys: ExpHeaderKeys;
  readonly getXLoBCommPrefsExpId: string;
  readonly getH100XLoBCommPrefsExpId: string;
  readonly updateCommPrefsExperienceId: string;
  readonly updateH100CommPrefsExperienceId: string;
  readonly updatePharmacyHeaderKeys: ExpHeaderKeys;
  readonly updateH100PharmacyHeaderKeys: ExpHeaderKeys;
}

export const ENVIRONMENT_CONFIG: { [key in AppEnvName]: EnvironmentConfig } = {
  [AppEnvName.prod]: {
    envName: AppEnvName.prod,
    domain: ['https://www.cvs.com', 'https://m.cvs.com', 'https://es.cvs.com', 'https://www-csr.cvs.com'],
    infoAPI: 'cnkL3GygZ8GgwivKfflt4q9R9UuROI4M',
    infoAPIHeader: undefined,
    experienceApiQee: 'HGNLXaQhG8CtglhHBvA7XD2TFnso1Scx',
    experienceClientId: 'cvs_account',
    getCommPrefsExperienceId: 'c9c99643-a781-418f-af24-2abc01a07654',
    getH100CommPrefsExperienceId: '6f832693-10ef-442e-9cd3-719313c6f0ad',
    getRxCommPrefsExperienceId: '44b34774-7c7b-44ad-bfd9-f8d2e43c4236',
    getH100RxCommPrefsExperienceId: '8bef4f98-b464-4690-8e0e-d1ec35900959',
    getExtraCareProfileInfoExperienceId: 'b3f243f6-e42a-495f-bf83-0f49841c06a9',
    updateExtraCareProfileInfo: '282d6906-e503-44f6-a9fd-59ec50e51910',
    updateCommPrefsExperienceId: 'dc6860d4-cffa-4191-abbf-94cc06adec14',
    updateH100CommPrefsExperienceId: 'ea8a0a06-d22b-421a-afc7-e0e4ffc2dff9',
    updatePharmacyHeaderKeys: {
      clientId: 'account_management',
      experienceId: '936b290d-fd71-4c10-b12c-bf48d38f2d4f',
    },
    updateH100PharmacyHeaderKeys: {
      clientId: 'account_management',
      experienceId: 'c9e1e166-b546-49cc-b0e0-53382b0426c2',
    },
    getExtracareInfoHeaderKeys: {
      clientId: 'account_management',
      experienceId: 'cf68c3dc-897c-4c54-adfc-8556b1e7504b',
    },
    getXLoBCommPrefsExpId: '71d124e7-2a2a-4030-a3ac-3820ef566502',
    getH100XLoBCommPrefsExpId: 'b4bedc48-de54-4716-8dea-75e74b9478d6',
  },
  [AppEnvName.qa1]: {
    envName: AppEnvName.qa1,
    domain: ['https://www-qa1.cvs.com'],
    infoAPI: 'oLNfoG2B8FnMAfNCkRLMiTgrlqkDjesz',
    infoAPIHeader: 'pt2',
    experienceApiQee: 'PRX4fYhAfVTr3UH3tSOTlb9oYNrAPUjA',
    experienceClientId: 'cvs_account',
    getCommPrefsExperienceId: 'c9c99643-a781-418f-af24-2abc01a07654',
    getH100CommPrefsExperienceId: '6f832693-10ef-442e-9cd3-719313c6f0ad',
    getRxCommPrefsExperienceId: '44b34774-7c7b-44ad-bfd9-f8d2e43c4236',
    getH100RxCommPrefsExperienceId: '8bef4f98-b464-4690-8e0e-d1ec35900959',
    getExtraCareProfileInfoExperienceId: 'b3f243f6-e42a-495f-bf83-0f49841c06a9',
    updateExtraCareProfileInfo: '282d6906-e503-44f6-a9fd-59ec50e51910',
    updateCommPrefsExperienceId: 'dc6860d4-cffa-4191-abbf-94cc06adec14',
    updateH100CommPrefsExperienceId: 'ea8a0a06-d22b-421a-afc7-e0e4ffc2dff9',
    updatePharmacyHeaderKeys: {
      clientId: 'account_management',
      experienceId: '936b290d-fd71-4c10-b12c-bf48d38f2d4f',
    },
    updateH100PharmacyHeaderKeys: {
      clientId: 'account_management',
      experienceId: 'c9e1e166-b546-49cc-b0e0-53382b0426c2',
    },
    getExtracareInfoHeaderKeys: {
      clientId: 'account_management',
      experienceId: 'cf68c3dc-897c-4c54-adfc-8556b1e7504b',
    },
    getXLoBCommPrefsExpId: '71d124e7-2a2a-4030-a3ac-3820ef566502',
    getH100XLoBCommPrefsExpId: 'b4bedc48-de54-4716-8dea-75e74b9478d6',
  },
  [AppEnvName.local]: {
    envName: AppEnvName.local,
    domain: ['http://localhost:3000'],
    defaultHeaderURL: 'https://www-qa2.cvs.com',
    infoAPI: '',
    infoAPIHeader: undefined,
    experienceApiQee: 'PRX4fYhAfVTr3UH3tSOTlb9oYNrAPUjA',
    experienceClientId: 'cvs_account',
    getCommPrefsExperienceId: 'c9c99643-a781-418f-af24-2abc01a07654',
    getH100CommPrefsExperienceId: '6f832693-10ef-442e-9cd3-719313c6f0ad',
    getRxCommPrefsExperienceId: '44b34774-7c7b-44ad-bfd9-f8d2e43c4236',
    getH100RxCommPrefsExperienceId: '8bef4f98-b464-4690-8e0e-d1ec35900959',
    getExtraCareProfileInfoExperienceId: 'b3f243f6-e42a-495f-bf83-0f49841c06a9',
    updateExtraCareProfileInfo: '282d6906-e503-44f6-a9fd-59ec50e51910',
    updateCommPrefsExperienceId: 'dc6860d4-cffa-4191-abbf-94cc06adec14',
    updateH100CommPrefsExperienceId: 'ea8a0a06-d22b-421a-afc7-e0e4ffc2dff9',
    updatePharmacyHeaderKeys: {
      clientId: 'account_management',
      experienceId: '936b290d-fd71-4c10-b12c-bf48d38f2d4f',
    },
    updateH100PharmacyHeaderKeys: {
      clientId: 'account_management',
      experienceId: 'c9e1e166-b546-49cc-b0e0-53382b0426c2',
    },
    getExtracareInfoHeaderKeys: {
      clientId: 'account_management',
      experienceId: 'cf68c3dc-897c-4c54-adfc-8556b1e7504b',
    },
    getXLoBCommPrefsExpId: '71d124e7-2a2a-4030-a3ac-3820ef566502',
    getH100XLoBCommPrefsExpId: 'b4bedc48-de54-4716-8dea-75e74b9478d6',
  },
  [AppEnvName.qa2]: {
    envName: AppEnvName.qa2,
    domain: ['https://www-qa2.cvs.com', 'https://www-qa-csr.cvs.com'],
    infoAPI: 'oLNfoG2B8FnMAfNCkRLMiTgrlqkDjesz',
    infoAPIHeader: 'QA2',
    experienceApiQee: 'PRX4fYhAfVTr3UH3tSOTlb9oYNrAPUjA',
    experienceClientId: 'cvs_account',
    getCommPrefsExperienceId: 'c9c99643-a781-418f-af24-2abc01a07654',
    getH100CommPrefsExperienceId: '6f832693-10ef-442e-9cd3-719313c6f0ad',
    getRxCommPrefsExperienceId: '44b34774-7c7b-44ad-bfd9-f8d2e43c4236',
    getH100RxCommPrefsExperienceId: '8bef4f98-b464-4690-8e0e-d1ec35900959',
    getExtraCareProfileInfoExperienceId: 'b3f243f6-e42a-495f-bf83-0f49841c06a9',
    updateExtraCareProfileInfo: '282d6906-e503-44f6-a9fd-59ec50e51910',
    updateCommPrefsExperienceId: 'dc6860d4-cffa-4191-abbf-94cc06adec14',
    updateH100CommPrefsExperienceId: 'ea8a0a06-d22b-421a-afc7-e0e4ffc2dff9',
    updatePharmacyHeaderKeys: {
      clientId: 'account_management',
      experienceId: '936b290d-fd71-4c10-b12c-bf48d38f2d4f',
    },
    updateH100PharmacyHeaderKeys: {
      clientId: 'account_management',
      experienceId: 'c9e1e166-b546-49cc-b0e0-53382b0426c2',
    },
    getExtracareInfoHeaderKeys: {
      clientId: 'account_management',
      experienceId: 'cf68c3dc-897c-4c54-adfc-8556b1e7504b',
    },
    getXLoBCommPrefsExpId: '71d124e7-2a2a-4030-a3ac-3820ef566502',
    getH100XLoBCommPrefsExpId: 'b4bedc48-de54-4716-8dea-75e74b9478d6',
  },
};
